export default __webpack_public_path__ + "static/media/create-proposal-gray.194b9ccf.svg";